export default "__VITE_ASSET__P4AuU4wc__"